import React from 'react';

interface Props {
  currentPage?: number;
  itemDescription?: string;
  loading?: boolean;
  pageSize?: number;
  totalCount?: number;
}

export default function PageHeaderCount({ currentPage, itemDescription, loading, pageSize, totalCount }: Props) {
  if (!currentPage || !pageSize || !totalCount || loading) {
    return null;
  }

  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalCount);
  return (
    <span className="text-muted d-none d-md-block">
      Displaying <strong>{start}-{end}</strong> of{' '}
      <strong>{totalCount}</strong>
      {itemDescription ? ` ${itemDescription}` : ''}
    </span>
  );
}
